import draftOptions from '../config/draftOptions.json'
import classNames from 'classnames';
import { findMap } from '../helpers/drafting';
import { useId, useState, useEffect } from 'react'

export function MapSelector({ map, state, leftSide, allowEmpty, iconMode, onChange, maps, index }) {

	const id = useId()

	// keep local selectedValue in sync with incoming props so resets update the select immediately
	const [selectedValue, setSelectedValue] = useState(map || '');

	useEffect(() => {
		if (maps) {
			const found = maps.find(m => m.label === map);
			setSelectedValue(found?.label || map || '');
		} else {
			setSelectedValue(map || '');
		}
	}, [map, maps]);

	const selectedMap = findMap(selectedValue, { withFallback: true }) || {};

	function handleChange(el) {
		const val = el.target.value;
		setSelectedValue(val);
		let side = leftSide ? 'host' : 'guest'
		console.log(side)
		if (onChange)
			onChange(val, index, side);
	}

	const randomMap = '/maps/megarandom.png';

	return (
		<div className={classNames('flex', !!leftSide ? 'flex-row' : 'flex-row-reverse')}>
			{iconMode === 'small' && <img className='w-8 h-8' src={selectedMap?.iconUrl || randomMap} />}
			<select key={id} id={id} value={selectedMap?.label ?? selectedValue} className={classNames('border-solid  border-[0.5px] h-8 w-32',state === "ban" && "bg-red-200", state === "pick" && "bg-green-200")} onChange={handleChange}>
				{allowEmpty && <option value=''>(unknown)</option>}
				{maps?.sort((a, b) => a.label.localeCompare(b.label)).map(mapOption => <option key={mapOption.label} value={mapOption.label}>{mapOption.label}</option>)}
			</select>
			{state && <select defaultValue={state} className='border-solid border-zinc-600 border-[0.5px] h-8 w-16'>{draftOptions.map(option => <option key={option} value={option}>{option}</option>)}</select>}
			{iconMode === 'below' && <img className='mx-auto w-20 h-20' src={selectedMap?.iconUrl || randomMap} />}
		</div>
	);
}